export default __webpack_public_path__ + "static/media/logo-footer.a417dab3.svg";